import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { DropdownType } from '@components/dropdown-base/dropdown-type';
import { DropdownWrapperComponent } from '@components/dropdown-base/wrapper/dropdown-wrapper.component';
import { getValueAccessorProvider } from '@core/utils/form';

@Component({
    selector: 'ihd-dropdown-v2',
    templateUrl: 'dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [getValueAccessorProvider(DropdownComponent)],
    host: {
        class: 'c-dropdown-v2',
        '[attr.tabindex]': '-1',
    }
})
export class DropdownComponent extends DropdownWrapperComponent implements OnInit, OnDestroy, ControlValueAccessor {

    public override dropdownType: DropdownType = DropdownType.DROPDOWN;

    public TYPE_DROPDOWN = DropdownType.DROPDOWN;

    constructor(cdr: ChangeDetectorRef) {
        super(cdr);
    }
}
